import {
  FormBaseType,
  FormTemplateDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_AVAILIBLE_FORM_TEMPLATES = "GET_AVAILIBLE_FORM_TEMPLATES";
interface GetAvailableFormTemplates {
  formBaseType: FormBaseType;
}

const allowedRoles = [UserRole.Owner, UserRole.Manager];

export const fetchAvailableFormTemplates = async ({
  formBaseType,
}: GetAvailableFormTemplates): Promise<FormTemplateDto[]> => {
  const response =
    await formsApi.formsControllerGetAvailableFormTemplates(formBaseType);

  return response.data;
};

export const useGetAvailableFormTemplates = (
  user: UserProfileDto | null,
  formBaseType: FormBaseType,
): {
  availableFormTemplates: FormTemplateDto[] | undefined;
  availableFormTemplatesEnabled: boolean;
  isLoadingAvailableFormTemplates: boolean;
  isFetchingAvailableFormTemplates: boolean;
  isSuccessAvailableFormTemplates: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { data, isLoading, isFetching, isSuccess } = useQuery<
    FormTemplateDto[],
    Error
  >({
    queryKey: [DOMAIN_FORMS, ACTION_GET_AVAILIBLE_FORM_TEMPLATES, formBaseType],
    queryFn: () => fetchAvailableFormTemplates({ formBaseType }),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    availableFormTemplates: data,
    availableFormTemplatesEnabled: enabled,
    isLoadingAvailableFormTemplates: isLoading,
    isFetchingAvailableFormTemplates: isFetching,
    isSuccessAvailableFormTemplates: isSuccess,
  };
};
